<template>
    <div class="md-layout info-panel">
        <md-content id="info-panel" class="md-layout-item">
            <md-card  md-with-hover class="md-layout">
                <toggle-dashboard class="md-layout-item"></toggle-dashboard>
                <div id="text" class="md-layout-item" >
                    <div>
                        <p>Zone: Horn of Africa</p>
                        <p>Country: {{ country[config.country]}}</p>
                        <p for="predictive" >
                            <span v-if="config.predictive == false">Date Range: Last {{ period[config.period] }} {{ dates }}</span>
                        </p>
                        <p for="predictive">
                            <span v-if="config.predictive == true">Year: {{year[config.year]}}</span>
                        </p>
                        <p for="predictive">
                            <span v-if="config.predictive == true">Scenario: {{scenario[config.scenario]}}</span>
                        </p>
                        <p>Workflow: {{ workflow[config.workflow]}}</p>
                        <p>Indicators: {{ indicators[config.workflow].join(', ') }}</p>
                    </div>
                </div>
            </md-card>
        </md-content>
    </div>
</template>

<script>
import ToggleDashboard from "@/components/OADashboard/ToggleDashboard.vue";
import moment from "moment";
export default {
    name: "InfoPanel",
    data() {
        return {
            predictive: true, 
            country: {
                "HOA": "All countries",
                "DJI": "Djibouti",
                "ERI": "Eritrea",
                "ETH": "Ethiopia",
                "KEN": "Kenya",
                "SOM": "Somalia",
                "SSD": "South Sudan",
                "SDN": "Sudan",
                "UGA": "Uganda"
            },
            period: {365: 'Year', 180: 'Six Months', 90: '90 days'},
            year: {'2030':'2030', '2050':'2050', '2080':'2080'},
            scenario: {'rcp45': 'RCP4.5', 'rcp85': 'RCP8.5'},
            workflow: {'SIMPLE': 'Simple', 'DROUGHT': 'Drought','ENV':'Environmental security extensive', 'CLIMATE': 'Climate security simple', 'FUTURE':'Future climate security'},
            indicators: {
                DROUGHT: ['Agricultural Drought', 'Meterological Drought', 'Heatwave', 'Displacement'],
                // SIMPLE: ['Agricultural Drought', 'Coastal Inundation Risk', 'Explosions and Remote Violence', 'Riots', 'Elderly Population'], 
                CLIMATE: ['Agricultural drought', 'Flood likelihood', 'Violence against civilians', 'Food insecurity', 'Displacement'], 
                ENV: ['Agricultural drought', 'Meterological drought', 'Heatwave', 'Flood likelihood', 'Coastal inundation risk', 'Deforestation', 'Land degradation','Explosions/Remote violence', 'Violence against civilians', 'Protests', 'Riots', 'Battles', 'Displacement', 'Travel time to urban areas','Access to electricity', 'Accessibility to healthcare (walking only)', 'Food insecurity', 'Urban expansion', 'Irrigation', 'Sanitation'],
                FUTURE: ['Precipitation', 'Temperature (future)','Flood likelihood (future)']
            }
        }
    },
    computed: {
        config(){
            return this.$store.getters['dashboard/getConfig'];
        },
        dates() {
            let from = moment().subtract(this.config.period, 'days').format('MM-DD-YYYY');
            let to = moment().format('MM-DD-YYYY');
            return `(${from} - ${to})`
        }
    },
    components: {
        ToggleDashboard,
    }
}
</script>

<style scoped>
.info-panel p {
    margin: 0
}

#info-panel {
    padding: 8px;
    font-weight: 600;
    font-size: 1.2em;
    margin-right: 24px;
}
#info-panel .md-card {
    margin: 8px;
}
#text {
    padding: 10px;
}
span {
    padding-top: 20px 0 0 0;
    margin-right: 8px;
}

@media screen and (max-device-width: 1024px) {
  #info-panel {
      margin-right: 8px;
  }
  .md-layout {
    margin: 0px;
    padding-right: 0px;
  }
  .md-app-content .md-card {
    padding: 26px;
    /* margin-right: 0px; */
  }
}
</style>